<template>
  <InfoPreparingPage v-if="ready && !isAdminLoggedIn" />
  <router-view v-else-if="ready" />
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useAdminAuth } from '@/composables/useAdminAuth'
import InfoPreparingPage from './InfoPreparingPage.vue'

const { isAdminLoggedIn, initAdminAuth } = useAdminAuth()
const ready = ref(false)

onMounted(async () => {
  await initAdminAuth()
  ready.value = true
})
</script>
